import { useFormik } from 'formik'
import React, { useCallback, useEffect, useState } from 'react'
import Modal from 'react-responsive-modal'
import { Checkbox, Input, Select, Textarea } from '../../components/ModalInputs'
import Button from '../../components/Button'
import styles from './styles.module.scss'
import { useDispatch, useSelector } from 'react-redux'
import { getCandidateNotifications, sendCandidateNotification } from '../../actions/candidates'
import { createNotification } from '../../components/Notifications/Notifications'
import { api } from '../../App'
import moment from 'moment'
import Confirmation from '../../components/Confirmation/Confirmation'

const SEND_MODES = [
  { name: 'e-mail', value: 0 },
  { name: 'печать/почта', value: 1 }
]

const INIIT_VALUES = {
  body: '',
  header: '',
  mail_date: moment().format('YYYY-MM-DD'),
  test_mail: false,
  test_mail_text: '',
  send_mode: 0,
  mail_type: '',
  no_resend: false,
  deferred: false,
  signature_post: '',
  signature_fio: ''
}

const NoticeModal = ({ open, closeModal, selectedEmails }) => {

  const dispatch = useDispatch()

  const { notifications } = useSelector(state => state.candidates.data)

  useEffect(() => {
    if (!open) return;
    setValues(INIIT_VALUES)
    dispatch(getCandidateNotifications())
    getOptions()
  }, [open])

  const getOptions = async () => {
    try {
      const { data } = await api.get('/options/applicant_letters')
      const initParams = data.options.reduce((acc, param) => ({ ...acc, [param.name]: param.value }), {})
      // INIIT_VALUES перекрывают initParams — поведенческие поля (send_mode, mail_type и т.д.) всегда из defaults
      setValues({ ...initParams, ...INIIT_VALUES })
    } catch {
      // /options/applicant_letters недоступен — остаёмся на INIIT_VALUES
    }
  }

  const formik = useFormik({
    initialValues: {},
    onSubmit: console.log
  })

  const {
    values,
    errors,
    handleChange,
    handleSubmit,
    setValues,
    setFieldValue
  } = formik

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => { if (formik.dirty) setConfirmClose(true); else closeModal() }, [formik.dirty, closeModal])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])


  const renderOptions = ({ description, name, value }) => <option value={value} key={value}>{description || name}</option>
  const renderNotificationOption = ({ id, value, name, description }) => {
    const optValue = value ?? id
    return <option value={optValue} key={optValue}>{description || name}</option>
  }

  const sendNoticeHandler = () => {
    const {
      body,
      header,
      mail_date,
      send_mode,
      mail_type,
      no_resend,
      deferred,
      signature_post,
      signature_fio
    } = values

    const applicant_ids = selectedEmails?.map(item => item.id) || []
    const applicantNames = selectedEmails?.map(item => item.calc_fio).filter(Boolean) || []

    if (!applicant_ids.length) {
      return createNotification('error', 'Необходимо выбрать хотя бы одного претендента')
    }

    const mailTypeNum = Number(mail_type)
    if (!mail_type || isNaN(mailTypeNum)) {
      return createNotification('error', 'Необходимо выбрать тип извещения')
    }

    const payload = {
      applicant_ids,
      mail_type: mailTypeNum,
      send_mode: Number(send_mode) || 0,
      mail_date,
      header,
      body,
      signature_post: signature_post || '',
      signature_fio: signature_fio || '',
      no_resend: Boolean(no_resend),
      deferred: Boolean(deferred)
    }

    dispatch(sendCandidateNotification(payload, applicantNames))
    closeModal()
  }

  const sendModeHandler = (e) => {
    handleChange(e)
    setFieldValue('test_mail', false)
    setFieldValue('test_mail_text', '')
  }

  return (
    <Modal
      open={open}
      onClose={handleClose}
      showCloseIcon={false}
      classNames={{ modal: styles.noticeModal }}
      closeOnEsc={true}
      closeOnOverlayClick={true}
      animationDuration={1}
    >
      <div>
        <h2>Рассылка извещений</h2>
      </div>
      <div>
        <div className={styles.noticeFirstRow}>
          <div>
            <Select
              label='Режим отправки'
              name='send_mode'
              value={values.send_mode}
              onChange={sendModeHandler}
            >
              {SEND_MODES.map(renderOptions)}
            </Select>
            <Checkbox
              label='Не отправлять повторно'
              name='no_resend'
              checked={values.no_resend}
              onChange={() => setFieldValue('no_resend', !values.no_resend)}
            />
          </div>
          <div>
            <Checkbox
              label='Отложенная отправка'
              name='deferred'
              checked={values.deferred}
              onChange={() => setFieldValue('deferred', !values.deferred)}
            />
            <Input
              type='date'
              label='Дата извещения'
              name='mail_date'
              value={values.mail_date}
              onChange={handleChange}
            />
          </div>
        </div>
        <Select
          label='Извещение'
          name='mail_type'
          value={values.mail_type}
          onChange={handleChange}
          style={{ width: '100%' }}
        >
          <option value="">Выберите тип извещения</option>
          {notifications?.map(renderNotificationOption)}
        </Select>
        <Input
          label='Тема письма'
          name='header'
          value={values.header}
          onChange={handleChange}
          style={{ width: '100%' }}
        />
        <div className={styles.noticeSecondRow}>
          <Input
            style={{ width: '376px' }}
            label='Краткое название (далее по тексту)'
            name='SchoolReference'
            value={values.SchoolReference}
            onChange={handleChange}
          />
          <Input
            style={{ width: '376px' }}
            label='(прибыть в)'
            name='ExamAddress2'
            value={values.ExamAddress2}
            onChange={handleChange}
          />
        </div>
        <Textarea
          label='Текст письма'
          className={styles.noticeTextarea}
          name='body'
          value={values.body}
          onChange={handleChange}
        />
        <Input
          label='Должность (подпись)'
          name='signature_post'
          value={values.signature_post}
          onChange={handleChange}
          style={{ width: '100%' }}
        />
        <Input
          label='ФИО (подпись)'
          name='signature_fio'
          value={values.signature_fio}
          onChange={handleChange}
          style={{ width: '100%' }}
        />
        {values.send_mode == 0 &&
          <div className={styles.testNotice}>
            <Checkbox
              label='Тестовая отправка'
              name='test_mail'
              checked={values.test_mail}
              onChange={() => setFieldValue('test_mail', !values.test_mail)}
            />
            <Input
              name='test_mail_text'
              value={values.test_mail_text}
              onChange={handleChange}
              disabled={!values.test_mail}
            />
          </div>}
      </div>
      <div className={styles.buttonsBlock}>
        <Button onClick={sendNoticeHandler}>Отправить</Button>
        <Button onClick={closeModal}>Отмена</Button>
      </div>
      {confirmClose && (
        <Confirmation
          title="Закрыть без сохранения изменений?"
          acceptConfirmation={acceptConfirmation}
          rejectConfirmation={rejectConfirmation}
        />
      )}
    </Modal>
  )
}

export default NoticeModal